import { types, Instance, SnapshotIn, destroy, getParent } from 'mobx-state-tree';
import { callAgroApi } from '@services/agroapi';
import { LabelResponse } from '@services/responseTypes';
import { Transformers } from '@services/transformer';
export const Label = types.model({
  id: types.identifier,
  name: types.string,
  color: types.string,
  description: types.maybeNull(types.string),
  readOnly: types.boolean,
  organizationId: types.string
}).actions(self => ({
  updateFromApi(lbl: LabelResponse) {
    self.name = lbl.name;
    self.color = lbl.color;
    self.description = lbl.description;
  },
  update(params: {
    name: string;
    color: string;
    description: string;
  }) {
    return callAgroApi<LabelResponse>(`/organizations/${self.organizationId}/labels/${self.id}`, 'PATCH', params).then(({
      data
    }) => {
      this.updateFromApi(data);
      return self;
    });
  },
  delete() {
    return callAgroApi<LabelResponse>(`/organizations/${self.organizationId}/labels/${self.id}`, 'DELETE').then(({
      data
    }) => {
      const store = getParent<ILabelStore>(self, 2) as ILabelStore;
      store.removeFromLabels(self as ILabel);
      return data;
    });
  }
}));
export type ILabel = Instance<typeof Label>;
export type ILabelSnapshotIn = SnapshotIn<typeof Label>;
export const LabelStore = types.model('LabelStore', {
  labels: types.map(Label)
}).actions(self => ({
  pushToLabels(lbl: LabelResponse) {
    self.labels.put(Transformers.lbl(lbl));
    return self.labels.get(lbl.id);
  },
  removeFromLabels(lbl: ILabel) {
    destroy(lbl);
  }
})).actions(self => ({
  createLabel(params: {
    name: string;
    color: string;
    description: string;
  }) {
    const orgId = getParent<{
      id: string;
    }>(self).id;
    return callAgroApi<LabelResponse>(`/organizations/${orgId}/labels`, 'POST', params).then(({
      data
    }) => self.pushToLabels(data));
  }
}));
export type ILabelStore = Instance<typeof LabelStore>;